import './App.css';

import React from 'react';
import CodeReview from './components/CodeReview/CodeReview';
import Home from './components/Home/Home';

function App() {

 
  return (
    <div className="App">
     <Home/>
     {/* <CodeReview /> */}
      

    </div>
  );
}



export default App;
